import { motion } from "framer-motion";

export default function Why() {
  return (
    <section className="bg-white border-y border-zinc-100" data-testid="porque-purpose-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20 py-24 lg:py-36">
        <div className="max-w-3xl mx-auto text-center">
          <p className="text-xs uppercase tracking-widest font-medium text-zinc-500 mb-5">Por qué lo hacemos</p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-zinc-900 leading-tight">
            La industria genera conocimiento cada día. Demasiado acaba perdiéndose.
          </h2>
          <div className="space-y-6 text-lg text-zinc-600 leading-relaxed mt-10 max-w-2xl mx-auto">
            <p>
              Una reparación. Una fotografía. Una modificación. Un esquema actualizado.
              Una solución que encontró un técnico hace tres años.
            </p>
            <p>
              Son pequeñas piezas de conocimiento que determinan cómo se entiende una máquina.
              Sin embargo, demasiadas veces terminan dispersas entre personas, carpetas y sistemas.
            </p>
            <motion.p
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: 0.2 }}
              className="text-zinc-900 font-medium text-xl"
            >
              Creemos que cada máquina debería conservar su propia historia.
            </motion.p>
            <p>
              Por eso estamos construyendo una forma mucho más sencilla de crear una identidad
              digital permanente para los equipos industriales.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
